import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

/** Breadcrumb "Grup › Cabang › Jenjang" per brief §5.
 *  Only renders segments the school actually has attached — a fully-flat school (no
 *  campus/group hierarchy) is rendered without crumbs so we don't show empty chevrons.
 */
export default function SchoolBreadcrumb({ school }) {
  if (!school) return null;
  const groupSlug = school.group_slug || null;
  const groupName = school.group_name || null;
  const campusSlug = school.campus_slug || null;
  const campusName = school.campus_name || null;
  // Level label preference: use the first education_level (TK/SD/SMP/SMA) if present.
  const jenjang =
    (Array.isArray(school.education_levels) && school.education_levels[0]) ||
    (typeof school.level === "string" ? school.level.toUpperCase() : null);

  if (!groupSlug && !campusSlug) return null;

  return (
    <nav aria-label="Breadcrumb" className="mb-3" data-testid="school-breadcrumb">
      <ol className="flex items-center gap-1 text-xs text-[#4B5563] flex-wrap">
        {groupSlug && groupName && (
          <li className="flex items-center gap-1">
            <Link to={`/grup/${groupSlug}`} className="hover:text-[#D2673E] hover:underline underline-offset-2" data-testid="crumb-group">
              {groupName}
            </Link>
          </li>
        )}
        {groupSlug && campusSlug && <ChevronRight size={11} className="text-[#8A8F99]" aria-hidden />}
        {campusSlug && campusName && (
          <li className="flex items-center gap-1">
            <Link to={`/cabang/${campusSlug}`} className="hover:text-[#D2673E] hover:underline underline-offset-2" data-testid="crumb-campus">
              {campusName}
            </Link>
          </li>
        )}
        {jenjang && (campusSlug || groupSlug) && <ChevronRight size={11} className="text-[#8A8F99]" aria-hidden />}
        {jenjang && (
          <li className="text-[#1F2937] font-medium uppercase tracking-wide" data-testid="crumb-jenjang">
            {jenjang}
          </li>
        )}
      </ol>
    </nav>
  );
}
